module.exports = __webpack_public_path__ + "static/media/search-semantic.f952afa1.png";